<script lang="ts" setup>
	import type { ScrollTopProps } from '../../../types'
	import { useIntervalFn } from '@vueuse/core'
	// @ts-ignore
	import { onMounted, notify, useAppConfig, useColorMode } from '#imports'
	const { colorModePreference, checkInterval = 60000 } = defineProps<{
		colorModePreference?: 'light'|'dark'|'system',
		scrollTop?: ScrollTopProps,
		checkInterval?: number
	}>()

	const config = useAppConfig().gsmaterials.app

	if (colorModePreference || config.colorModePreference)
		useColorMode().preference = colorModePreference ?? config.colorModePreference


	onMounted(async () => {
		let check = await $fetch<{ buildtime: number }>('buildtime.json')

		useIntervalFn(async () => {
			const result  = await $fetch<{buildtime: number}>('buildtime.json')
			if (check.buildtime < result.buildtime)
				notify({
					title: 'Seite / Inhalte nicht mehr aktuell',
					description: 'Die Seite benötigt einen Reload.',
					color: 'info',
					type: 'foreground',
					duration: 1000000000,
					//vertical: false,
					actions: [
						{
							icon: 'i-mdi-sync',
							label: 'Neuladen',
							variant: "solid",
							color: 'info',
							size: "xl",
							onClick: () => location.reload()
						}
					]
				})
			check = result
		}, checkInterval)
	})
</script>
<template>
	<UApp v-bind="config.toaster">
		<Head>
			<Link rel="icon" type="image/x-icon" :href="usePublicUrl('/favicon.ico')" />
		</Head>
		<slot />
		<GsScrollTop v-bind="scrollTop ?? config.scrollTop" />
		<NuxtAnnouncer />
		<NuxtRouteAnnouncer/>
	</UApp>
</template>
